import Moveable, {
  LineDirection,
  OnClick,
  OnDrag,
  OnDragEnd,
  OnDragStart,
  OnEndEvent,
  OnResize,
  OnResizeEnd,
  OnResizeStart,
  OnRotate,
  OnRotateEnd,
  OnRotateStart,
  OnScale,
  OnScaleEnd,
  OnScaleStart,
  RectInfo,
  RenderDirections,
  ResizableOptions,
  ScalableOptions
} from "moveable";
import {MoveableOptions} from "react-moveable/types";
import React from "preact/compat";
import $ from 'jquery'
import Renderer from "./renderer";
import store from "../store";
import * as actions from "../actions";
import MenuObject from "./menu-object";
import Text from './text';
import util, {insertAndShift} from "../util";
import DimensionViewable from "./ables/DimensionViewable"
import FavoriteViewable from "./ables/FavoriteViewable"
import AngleViewable from "./ables/AngleViewable"
import {changeCircleSize, changeLineSize, changeSquareSize} from "./shape";
import Cleaner from "./cleaner";
import {deselectAll} from "./selection";
import {isElementOffPage} from "./component";
import History from "./history";
import {adjustAfterFrameResize} from "./reposition-frame";
import {
  AlignDirection,
  AlignType,
  ALL_SNAPS_DISABLED,
  ALL_SNAPS_ENABLED,
  AllowedElement,
  ATTR_NAME,
  ComponentType,
  CONTROL_BOX_CLASS_PREFIX,
  DEFAULT_SNAP_THRESHOLD,
  FORBIDDEN_KEYS_TO_CLONE,
  Frame,
  getConfig,
  InitialOptions,
  InteractionType,
  LEFT_RIGHT_SNAPS_ENABLED,
  LIGHT_CONTROLS_THRESHOLD,
  LOCKED_ATTR_NAME,
  LOCKED_FRAME_ATTR_NAME,
  PageCoordinate,
  SCALE_RESIZE_THRESHOLD,
  SCALE_RESIZE_THRESHOLD_SHAPE,
  SELECTOR_ALL_COMPONENTS,
  SORTABLE_OPTIONS,
  START_DIRECTIONS,
  START_FRAME,
  START_PAGE,
  START_STYLE,
  STRING_NUMBER_OBJECT,
  TargetType,
  TEXT_SNAP_THRESHOLD,
  TOP_BOTTOM_LEFT_RIGHT_DIRECTIONS,
  TOP_BOTTOM_SNAPS_ENABLED,
  Undo
} from "./interactable-constants";
import {
  decomposeMatrix,
  deepCopy,
  documentContainsElement,
  formatNumber,
  getDefaultFrame,
  getDraggedEdge,
  getOptionsByElement,
  getPageZoom,
  getUndoLabel,
  hideAngle,
  hideDimensions,
  hideFavorite,
  isBottomDrag,
  isBottomLeftDrag,
  isBottomRightDrag,
  isCornerDrag,
  isElementFavorite,
  isElementLocked,
  isLeftDrag,
  isLeftRightDrag,
  isRightDrag,
  isTopBottomDrag,
  isTopDrag,
  isTopLeftDrag,
  isTopRightDrag,
  showAngle,
  showDimensions,
  showFavorite
} from "./interactable-helpers";
import {fixComponentLineHeight} from "./line-height";
import LockedViewable from "./ables/LockedViewable";
import MultiInteractable from "./multiInteractable";
import MOOptions from "./ables/MOOptions";
import Options from "./ables/Options";
import canvas from "../canvas/index";
import Sortable from "sortablejs";
import { isMenuItemDataImportMode } from "../component/MenuItemDataImport";
import { wrapToCurve } from "./word-art";
import favoriteAssetService from "../service/favoriteAssetService";

export default class Interactable {
  public static MULTIINTERACTABLE?: MultiInteractable = undefined;
  private static INSTANCES = [] as Interactable[];
  private static PAGE_COORDINATES = [] as PageCoordinate[];
  private static IS_MOUSE_OVER_PAGE: boolean = false;
  private static LAST_ACTION_OVER_PAGE: boolean = false;
  private static MOUSE_OVER_INSTANCE: Interactable | null = null;

  public static refreshControls() {
    this.INSTANCES.filter(it => it.isValidInstance() && (it.options.selected || (it.mov && it.mov.hideDefaultLines))).forEach(i => {
      i.updateRect();
    });
    if (this.MULTIINTERACTABLE) {
      this.MULTIINTERACTABLE.mov.updateRect();
      let nowSelected = this.getSelected();
      nowSelected.forEach((ns) => ns.hideControls());
    }
  }

  private static isMultiselect() {
    return this.INSTANCES.filter(it => it.options.selected).length > 1;
  }

  private static getOtherSelectedInstances(instance: Interactable) {
    return this.INSTANCES.filter(it => it.isValidInstance() && it.options.selected && it !== instance);
  }

  public static clearMultiinteractable() {
    if (Interactable.MULTIINTERACTABLE) {
      Interactable.MULTIINTERACTABLE.mov.destroy();
      Interactable.MULTIINTERACTABLE = undefined;
    }
  }

  public static createMultiinteractable() {
    this.clearMultiinteractable();
    let nowSelected = Interactable.getSelected();
    if (Interactable.isMultiselect()) {
      Interactable.MULTIINTERACTABLE = MultiInteractable.getInstance(Interactable.getContainer(), nowSelected.map(it => it.$el[0]));
      nowSelected.forEach((ns) => ns.hideControls());
    } else {
      this.refreshControls();
    }
  }

  public static updateMultiinteractable() {
    if (Interactable.MULTIINTERACTABLE) {
      Interactable.MULTIINTERACTABLE.mov.updateRect();
    }
  }

  static {
    const $window = $(window);
    $window.on('resize', function () {
      Interactable.refreshControls();
      Interactable.refreshPageNumber();
    });

    setTimeout(() => {
      const throttleFn = util.throttle(function () {
        Interactable.refreshPageNumber();
      }, 30);

      $window.on('scroll', throttleFn);
    });

    setTimeout(() => {
      const throttleFn = util.throttle(function (ev: JQuery.MouseMoveEvent) {
        Interactable.onMouseMove(ev);
      }, 30);
      document.addEventListener('mousemove', throttleFn);
    });
  }

  public static maybeFixPages() {
    let hasWrongPages = false;
    $('.page[data-mstate]').each(function() {
      hasWrongPages = true;
      const $page = $(this);
      console.log('=> fixing page', $page);
      $page.removeAttr('data-mstate');
      $page.css({transform: ''});
    });

    if (hasWrongPages) {
      this.refreshControls();
    }
  }

  public static refreshPageNumber() {
    if (!store.getState().isMobileVersion) {
      this.PAGE_COORDINATES = [];
      $('.page .content').each(function () {
        const rect = $(this)[0].getBoundingClientRect();
        Interactable.PAGE_COORDINATES.push({
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: rect.height
        });
      });
    }
  }

  private static isOverPage(clientX: number, clientY: number) {
    for (let i = 0; i < Interactable.PAGE_COORDINATES.length; i++) {
      const entry = Interactable.PAGE_COORDINATES[i];
      const xOK = clientX >= entry.x && clientX <= entry.x + entry.width;
      const yOK = clientY >= entry.y && clientY <= entry.y + entry.height;

      if (xOK && yOK) {
        return true;
      }
    }
    return false;
  }

  private static handleElementVisibility(i: Interactable, hide: boolean) {
    i.mov.hideDefaultLines = hide;
    i.mov.edgeDraggable = hide ? false : (TOP_BOTTOM_LEFT_RIGHT_DIRECTIONS as LineDirection[]);
    if (hide) {
      i.mov.rotationPosition = 'none';
    }
    i.ensureControlsHidden();
    if (!hide && i.isLocked()) {
      util.nextTick(() => {
        const $lines = i.getControlBox().find('.moveable-edgeDraggable');
        $lines.addClass('locked');
        $lines.on('click', () => {
          i.$el.trigger('click');
        });
      });
    }
  }

  private static onMouseMove(ev: JQuery.MouseMoveEvent) {
    if (!store.getState().isMobileVersion && !Interactable.isInteracting()) {
      const clientX = ev.clientX;
      const clientY = ev.clientY;

      Interactable.IS_MOUSE_OVER_PAGE = Interactable.isOverPage(clientX, clientY);

      const validInstances = Interactable.getValidInstancesFromViewportPages();

      if (Interactable.IS_MOUSE_OVER_PAGE) {
        Interactable.LAST_ACTION_OVER_PAGE = true;
        Interactable.hideDragAreas();
        Interactable.MOUSE_OVER_INSTANCE = Interactable.maybeGetInstanceFromElement(ev.target);

        validInstances.forEach(i => {
          let hide = !i.options.selected && (i !== Interactable.MOUSE_OVER_INSTANCE);

          if (hide && i.isGroup && Interactable.MOUSE_OVER_INSTANCE && Interactable.MOUSE_OVER_INSTANCE.isInGroup() && i.$el[0] === Interactable.MOUSE_OVER_INSTANCE.getParentGroup()?.eq(0)[0]) {
            hide = false;
          }

          if (i.mov.hideDefaultLines !== hide) {
            this.handleElementVisibility(i, hide);
          }
        });
      } else {
        if (Interactable.LAST_ACTION_OVER_PAGE) {
          Interactable.LAST_ACTION_OVER_PAGE = false;

          Interactable.MOUSE_OVER_INSTANCE = null;
          Interactable.hideDragAreas();

          validInstances.forEach(i => {
            if (i.options.selected && !i.isFramePreview) {
              i.setDragArea(true);
            } else {
              i.setDragArea(false);
            }

            if (i.mov.hideDefaultLines !== !i.options.selected) {
              let hide = !i.options.selected;
              this.handleElementVisibility(i, hide);
            }
          });
        }
      }
    }
  }

  private static maybeGetInstanceFromElement(el: AllowedElement) {
    let instance: Interactable | null = null;
    if (el.classList.contains('select')) {
      instance = Interactable.of(el);
    }
    const $el = $(el);
    if (!instance && el.classList.contains('moveable-line')) {
      instance = Interactable.getInstanceFromControlBox($el);
    }
    if (!instance) {
      const $candidate = $el.closest('.select');
      if ($candidate && $candidate.length) {
        instance = Interactable.of($candidate);
      }
    }
    return instance;
    // const instances = Interactable.getValidInstances();
    // for (let i = 0; i < instances.length; i++) {
    //   if (instances[i].mov.hitTest(el)) {
    //     return instances[i];
    //   }
    // }
    // return null;
  }

  private static getValidInstances() {
    return Interactable.INSTANCES.filter(it => it.isValidInstance());
  }

  private static getValidInstancesFromViewportPages() {
    const $page = util.getPageInViewport($('.page')) as JQuery<AllowedElement> | null;
    if (!$page || !$page.length) return [];

    const pages = [$page] as JQuery<AllowedElement>[];
    const currentPageIdx = parseInt($page.attr('id')?.replace('page-', '') || '0');
    const $prevPage = $(`#page-${currentPageIdx - 1}`);
    const $nextPage = $(`#page-${currentPageIdx + 1}`);

    if ($prevPage.length) {
      pages.push($prevPage);
    }
    if ($nextPage.length) {
      pages.push($nextPage);
    }

    return this.getValidInstancesFromPages(pages);
  }

  private static getValidInstancesFromPages(pages: JQuery<AllowedElement>[]) {
    if (!pages || !pages.length) return [];

    const pageIdxs = pages.map(it => parseInt(it.attr('id')?.replace('page-', '') || '0'));

    return this.getValidInstances().filter(it => pageIdxs.includes(it.currentPageIdx));
  }

  public static showDragAreas() {
    this.getValidInstances().forEach(i => i.setDragArea(true));
  }

  public static hideDragAreas() {
    this.getValidInstances().forEach(i => i.setDragArea(false));
  }

  public static getIdFromMovableArea($moveableArea: JQuery<AllowedElement>) {
    const domParent = $moveableArea.parent()[0];
    if (!domParent) return null;
    return Interactable.getIdFromClasses(domParent.classList);
  }

  public static storeTempRatios() {
    this.INSTANCES.forEach(i => {
      if (i.isValidInstance()) {
        i.$el.attr('data-temp-ratio', i.getCurrentWidth() / i.getCurrentHeight());
      }
    });
  }

  public static getIdFromClasses(classes: DOMTokenList) {
    const cand = Array.from(classes).filter(it => it.indexOf(CONTROL_BOX_CLASS_PREFIX) > -1).map(it => it.replace(CONTROL_BOX_CLASS_PREFIX, ''));
    return cand && cand.length ? cand[0].trim() : null;
  }

  private static adaptAlignRect(rect: RectInfo, $page: JQuery<AllowedElement> | undefined, $elements: Array<JQuery<AllowedElement>>) {
    if ($page) {
      const $element = $elements.filter(it => it[0] !== $page[0])[0];
      const dims = util.getActiveDimensions();
      let bleed = util.inchToPixel(0.25);

      if (!Number.isFinite(bleed)) {
        bleed = 0;
      }

      rect.top = bleed;
      rect.height = ($page.height() || 0) - (bleed * 2);

      if (dims.hasFolds) {
        const page = util.getPageNumber($element);
        const panel = util.getPanelFold($element);
        const pageWidth = dims.width;
        const halfHalfBleedWidth = util.inchToPixel(0.25 / 2 / 2);
        const halfBleedWidth = halfHalfBleedWidth * 2;
        const pageOneFoldOne = util.inchToPixel(dims.pageOneFoldOne) || 0;
        const pageOneFoldTwo = util.inchToPixel(dims.pageOneFoldTwo) || 0;
        const pageOneFoldThree = util.inchToPixel(dims.pageOneFoldThree) || 0;
        const pageTwoFoldOne = util.inchToPixel(dims.pageTwoFoldOne) || 0;
        const pageTwoFoldTwo = util.inchToPixel(dims.pageTwoFoldTwo) || 0;
        const pageTwoFoldThree = util.inchToPixel(dims.pageTwoFoldThree) || 0;

        switch (page) {
          case 1:
            if (panel === 1) {
              rect.left = bleed;
              rect.width = pageOneFoldOne - halfBleedWidth - bleed;
            }
            if (panel === 2) {
              if (dims.pageOneFoldTwo) {
                rect.left = pageOneFoldOne + halfBleedWidth;
                rect.width = pageOneFoldTwo - pageOneFoldOne - bleed;
              } else {
                rect.left = pageOneFoldOne + halfBleedWidth;
                rect.width = pageWidth - pageOneFoldOne - (halfBleedWidth * 3);
              }
            }
            if (panel === 3) {
              if (dims.pageOneFoldThree) {
                rect.left = pageOneFoldTwo + halfBleedWidth;
                rect.width = pageOneFoldThree - pageOneFoldTwo - bleed;
              } else {
                rect.left = pageOneFoldTwo + halfBleedWidth;
                rect.width = pageWidth - pageOneFoldTwo - (halfBleedWidth * 3);
              }
            }
            if (panel === 4) {
              rect.left = pageOneFoldThree + halfBleedWidth;
              rect.width = pageWidth - pageOneFoldThree - (halfBleedWidth * 3);
            }
            break;
          case 2:
            if (panel === 1) {
              rect.left = bleed;
              rect.width = pageTwoFoldOne - halfBleedWidth - bleed;
            }
            if (panel === 2) {
              if (dims.pageTwoFoldTwo) {
                rect.left = pageTwoFoldOne + halfBleedWidth;
                rect.width = pageTwoFoldTwo - pageTwoFoldOne - bleed;
              } else {
                rect.left = pageTwoFoldOne + halfBleedWidth;
                rect.width = pageWidth - pageTwoFoldOne - (halfBleedWidth * 3);
              }
            }
            if (panel === 3) {
              if (dims.pageTwoFoldThree) {
                rect.left = pageTwoFoldTwo + halfBleedWidth;
                rect.width = pageTwoFoldThree - pageTwoFoldTwo - bleed;
              } else {
                rect.left = pageTwoFoldTwo + halfBleedWidth;
                rect.width = pageWidth - pageTwoFoldTwo - (halfBleedWidth * 3);
              }
            }
            if (panel === 4) {
              rect.left = pageTwoFoldThree + halfBleedWidth;
              rect.width = pageWidth - pageTwoFoldThree - (halfBleedWidth * 3);
            }
            break;
        }
      } else {
        rect.width = ($page.width() || 0) - (bleed * 2);
        rect.left = bleed;
      }
    }
  }

  public static alignElements(parentElement: AllowedElement, $elements: Array<JQuery<AllowedElement>>, type: AlignType, direction: AlignDirection, $page?: JQuery<AllowedElement>) {
    const actions = [] as { target: AllowedElement, translate: number[] }[];
    const targets = [] as Array<AllowedElement>;
    $elements.forEach($el => {
      targets.push($el[0]);
    });

    const groupMov = new Moveable(parentElement, {
      target: targets,
      hideDefaultLines: true,
      origin: false
    });

    const instancesToDestroy: Interactable[] = [];

    util.nextTick(() => {
      const rect = groupMov.getRect();
      Interactable.adaptAlignRect(rect, $page, $elements);
      const pos = Interactable.getDirectionPos(type, direction, rect);

      groupMov.getManager().moveables!.forEach(child => {
        const childInt = Interactable.of(child.state.target);
        const isPage = util.isPage(childInt.$el);
        if (isPage) {
          instancesToDestroy.push(childInt);
        }
        const frame = childInt.getFrame();

        if (frame) {
          const subRect = child.getRect();
          const subPos = Interactable.getDirectionPos(type, direction, subRect);
          const delta = pos - subPos;
          const translate = childInt.cloneCurrentFrame().translate;

          translate[type === AlignType.HORIZONTAL ? 1 : 0] += delta;

          if (!isPage) {
            actions.push({
              target: child.state.target as AllowedElement,
              translate
            });
          }
        }
      });

      groupMov.updateRect();
      groupMov.destroy();
      instancesToDestroy.forEach(i => Interactable.destroy(i));

      const events = actions.map(it => {
        const i = Interactable.of(it.target);

        const oldFrame = i.cloneCurrentFrame();
        const newFrame = i.cloneCurrentFrame();
        newFrame.translate = [...it.translate];

        const oldStyle = i.cloneCurrentStyle();
        const newStyle = i.cloneCurrentStyle();

        return {
          target: it.target,
          oldFrame,
          newFrame,
          oldStyle,
          newStyle
        }
      });

      Interactable.registerUndo(events, 'Align', true);
    });
  }

  private static getInstance(parentElement: AllowedElement, target: TargetType): Interactable {
    let instance = this.getIfExists(target);

    if (!instance) {
      instance = new Interactable(parentElement, target);
      Interactable.INSTANCES = Interactable.INSTANCES.filter(it => it.isValidInstance() && it.$el && documentContainsElement(it.$el));
      if (instance) {
        Interactable.INSTANCES.push(instance);
      }

      // @ts-ignore
      if (!window['IntDebug']) {
        // @ts-ignore
        window['IntDebug'] = Interactable;
      }
    }

    return instance;
  }

  public static getIfExists(targetParam: any): Interactable | undefined {
    const target = Interactable.getTarget(targetParam);
    return this.getValidInstances().find(it => it.$el[0] === target);
  }

  public static of(targetParam: any): Interactable {
    const target = Interactable.getTarget(targetParam);
    return Interactable.getInstance(Interactable.getContainer(), target);
  }

  private static getTarget(targetParam: any): AllowedElement {
    return (targetParam instanceof jQuery ? (targetParam as JQuery)[0] : targetParam) as AllowedElement;
  }

  public static destroy(instance: Interactable) {
    instance.destroy();
    Interactable.remove(instance);
  }

  public static destroyAll($except?: JQuery<AllowedElement>) {
    this.INSTANCES.forEach(it => {
      if (!$except || it.$el[0] !== $except[0]) {
        Interactable.destroy(it);
      }
    });
  }

  public static resetAllPositions() {
    Interactable.INSTANCES.forEach(i => {
      if (isElementOffPage(i.$el)) {
        i.setTranslateX(0);
        i.refreshPosition();

        util.nextTick(() => {
          if (isElementOffPage(i.$el)) {
            i.setTranslateY(0);
            i.refreshPosition();
          }
          i.ensureRatio();
        });
      } else {
        i.ensureRatio();
      }
    });
  }

  public static adjustSelectionBoxes() {
    this.getValidInstances().forEach(i => {
      i.updateRect(true);
    });
    util.nextTick(() => {
      this.refreshPageNumber();
    });
  }

  public static remove(instance: Interactable) {
    Interactable.INSTANCES = Interactable.INSTANCES.filter(it => (!it.destroyed && (it !== instance || documentContainsElement(it.$el))));
  }

  private static tempDisableControlBox() {
    const styles = document.createElement("style");
    styles.setAttribute("type", "text/css");
    styles.textContent = `.moveable-control-box{display:none !important;}`;
    document.head.appendChild(styles);
    return styles;
  }

  private static tempEnableControlBox(styles: Element) {
    setTimeout(() => {
      document.head.removeChild(styles);
    });
  }

  public static initElements() {
    const styles = this.tempDisableControlBox();
    $(SELECTOR_ALL_COMPONENTS).each(function () {
      Interactable.of($(this)[0]);
    });
    Interactable.deselectAll();
    this.tempEnableControlBox(styles);
  }

  public static getSelected() {
    return this.INSTANCES.filter(it => it.options.selected);
  }

  public static isInteracting() {
    return !!this.INSTANCES.filter(it => it.isInteracting).length;
  }

  public static deselectAll($except?: JQuery<AllowedElement>) {
    this.INSTANCES.forEach(it => {
      if (!$except || it.$el[0] !== $except[0]) {
        it.deselect();
      }
    });
  }

  private static getContainer() {
    return document.body;
  }

  public static selectFromMultiselection(target: TargetType) {
    this.clearMultiinteractable();
    Renderer.deselectAll();

    const $el = $(target as AllowedElement);
    Renderer.select($el, true);
    store.dispatch(actions.select($el));
    Interactable.of($el).showControls();
  }

  private readonly mov: Moveable;
  private readonly $el: JQuery<AllowedElement>;
  public readonly isGroup: boolean;
  private readonly isText: boolean;
  private readonly isMobile: boolean;
  private readonly isMO: boolean;
  private readonly isShape: boolean;
  private readonly isFrame: boolean;
  private readonly isFramePreview: boolean;
  private readonly isSquare: boolean;
  private readonly isLine: boolean;
  private readonly isCircle: boolean;
  private readonly isImage: boolean;
  private readonly isVideoFrame: boolean;
  private readonly isIllustration: boolean;
  private readonly isQR: boolean;
  private readonly isRatioConfigurableElement: boolean;
  private options: InitialOptions;
  private destroyed: boolean = false;
  // private lineObserver: MutationObserver | null = null;
  private isManualResizing: boolean = false;
  private isManualScaling: boolean = false;
  private isManualDragging: boolean = false;
  private startX: number = 0;
  private startY: number = 0;
  private rectInfo: RectInfo | null = {} as RectInfo;
  private currentPageIdx: number = 0;
  private skipSaveInchAttr: boolean = false;

  private frame = getDefaultFrame();
  private optionsBeforeLock = null;

  private isInteracting = false;
  private sortable: Sortable | null = null;

  private constructor(parentElement: AllowedElement, target: TargetType) {
    this.$el = $(target as AllowedElement);
    if (this.$el.hasClass('.page')) throw new Error('Cannot instantiate Interactable with a page element');

    this.isGroup = util.isGroup(this.$el);
    this.isText = util.isText(this.$el);
    this.isMO = MenuObject.isMenuObject(this.$el);
    this.isShape = util.isShape(this.$el);
    this.isFrame = util.isFrame(this.$el) && !util.isFramePreview(this.$el);
    this.isFramePreview = util.isFramePreview(this.$el);
    this.isSquare = util.isSquare(this.$el);
    this.isCircle = util.isCircle(this.$el);
    this.isLine = util.isLine(this.$el);
    this.isImage = util.isImage(this.$el);
    this.isVideoFrame = util.isVideoFrame(this.$el);
    this.isIllustration = util.isIllustration(this.$el);
    this.isQR = util.isQrCode(this.$el);
    this.isMobile = store.getState().isMobileVersion;

    if (this.isMobile) {
      Interactable.IS_MOUSE_OVER_PAGE = true;
    }

    this.isRatioConfigurableElement = this.isShape || this.isImage || this.isVideoFrame || this.isIllustration || this.isFrame;

    this.options = this.getOptions(target);

    this.mov = new Moveable(parentElement, this.options);

    if (!this.isFramePreview) {
      this.registerListeners();
    }
    this.restoreState(this.options);
    this.hideControls();
    this.afterObjectCreated();
    try {
      this.currentPageIdx = util.getPageNumber(this.$el);
    } catch (e) {
      console.error(e);
      this.currentPageIdx = 1;
    }
    if (this.isMO && this.frame.rotate === 0) {
      this.options.rotatable = false;
      this.onOptionsChanged();
    }
    //this.fixPosition();
  }

  private afterObjectCreated() {
    // if (this.isShape) {
    //   this.handleResizeShape();
    // }
    if (this.isMO) {
      this.fixPrevMOScale();
    }
    // if (this.isText) {
    //   this.fixPrevTextScale();
    // }
  }

  private fixPrevTextScale() {
    util.nextTick(() => {
      const $qlContainer = this.$el.find('.ql-container');
      const transform = $qlContainer.css('transform');
      if (!!transform && transform !== 'none') {
        const scale = decomposeMatrix(new DOMMatrix(transform)).scaleX || 1;
        if (scale !== 1) {
          const oldRect = this.mov.getRect();

          $qlContainer.css({
            'transform': '',
            'width': '',
            'height': ''
          });
          this.setScale(scale);
          this.refreshPosition();

          util.nextTick(() => {
            this.moveTo(oldRect.pos1[0], oldRect.pos1[1]);
            this.deselect();
          });
        }
      }
    });
  }

  private fixPrevMOScale() {
    util.nextTick(() => {
      const $wrapper = this.$el.find('.wrapper');
      const transform = $wrapper.css('transform');
      if (!!transform && transform !== 'none') {
        const scale = decomposeMatrix(new DOMMatrix(transform)).scaleX || 1;
        if (scale !== 1) {
          const oldRect = this.mov.getRect();

          const oldWidth = $wrapper.width();
          const oldHeight = $wrapper.height();

          this.$el.css({width: `${oldWidth}px`, height: `${oldHeight}px`});

          $wrapper.css({
            'transform': '',
            'width': '',
            'height': ''
          });
          this.setScale(scale);
          this.refreshPosition();

          util.nextTick(() => {
            this.moveTo(oldRect.pos1[0], oldRect.pos1[1]);
            this.deselect();
          }, 3);
        }
      }

      util.nextTick(() => {
        MenuObject.fixDots(this.$el);
      });
    });
  }

  private observeLines() {
    // this.lineObserver?.observe(this.getControlBox()[0], {childList: true, subtree: true});
  }

  private stopObservingLines() {
    // this.lineObserver?.disconnect();
  }

  // private registerLineListener() {
  // this.lineObserver = new window.MutationObserver(mutations => mutations.forEach((m) => {
  //   $(m.target).find('.moveable-line.moveable-guideline.moveable-bold:not(.moveable-snap)').each(function () {
  //     const DIFF = 5;
  //     const $this = $(this);
  //     const $element = Interactable.getElementFromControlBox($this);
  //     if (!$element) return;
  //
  //     const $page = $element.closest('.page');
  //     const zoom = getPageZoom();
  //     const elemHeight = Math.round($this.height() || 0);
  //     const elemWidth = Math.round($this.width() || 0);
  //     const pageHeight = Math.round(($page.height() || 0) * zoom);
  //     const pageWidth = Math.round(($page.width() || 0) * zoom);
  //     const heightDiff = Math.abs(elemHeight - pageHeight);
  //     const widthDiff = Math.abs(elemWidth - pageWidth);
  //
  //     if (heightDiff < DIFF || widthDiff < DIFF) {
  //       $(this)[0].style.setProperty('border-left', '1px solid #e42436', 'important');
  //       $(this)[0].style.setProperty('border-top', '1px solid #e42436', 'important');
  //     }
  //   });
  // }));
  // }

  private destroy() {
    //console.log('Destroying', this);

    if (!this.isFramePreview) {
      this.saveState();
    } else {
      //Interactable.of(this.getFrameObject()).setDragArea(true);
    }

    if (this.mov) {
      this.mov.clickable = false;
      this.mov.preventClickDefault = false;
      this.mov.preventClickEventOnDrag = false;
      this.mov.destroy();
    }
    this.stopObservingLines();
    this.destroyed = true;
    this.getControlBox().remove();
    if (this.isText && this.isMobile) {
      this.$el.find('.txt').off('touchstart');
      this.$el.find('.txt').off('touchend');
    }
  }

  private getOptions(target: TargetType): InitialOptions {
    const ops = {
      ...getOptionsByElement(target),
      ...this.getAbleOptions(),
      target,
      className: `${this.getControlBoxClass()}`,
      selected: false,
    } as InitialOptions;

    if (this.isRatioConfigurableElement) {
      ops.scalable = false;
    }

    if (this.isGroup) {
      if (this.hasLockedElements()) {
        ops.draggable = false;
      }
    }

    if (this.isInGroup()) {
      ops.rotatable = false;
      ops.resizable = false;
      ops.draggable = false;
      ops.scalable = false;
      ops.edge = false;
      ops.edgeDraggable = false;
      ops.useResizeObserver = false;
    }

    if (this.isMobile) {
      ops.preventClickDefault = false;
      ops.preventClickEventOnDrag = false;
      ops.pinchOutside = false;
      ops.stopPropagation = false;

      if (this.isText) {
        ops.clickable = true;
        ops.checkInput = true;
      }
    }

    return ops;
  }

  private getAbleOptions(): MoveableOptions {
    if (this.isFramePreview) return {
      ables: [],
      props: {
        dimensionViewable: false,
        angleViewable: false,
        lockedViewable: false,
        favoriteViewable: false,
        interactable: this
      }
    };

    const ables = {
      ables: [DimensionViewable, AngleViewable, LockedViewable],
      props: {
        dimensionViewable: true,
        angleViewable: true,
        lockedViewable: true,
        favoriteViewable: false,
        interactable: this
      }
    };

    if (this.isMO) {
      ables.ables.push(MOOptions);
      //@ts-ignore
      ables.props['mooptions'] = true;
    }

    if (this.isImage || this.isIllustration || this.isFrame && !this.isVideoFrame) {
      if ((this.isFrame || this.isImage || this.isIllustration) && (!this.$el.attr('data-id') && !this.$el.attr('data-asset-id') && !this.$el.attr('data-pixabay-info'))) {
        ables.ables.splice(ables.ables.indexOf(FavoriteViewable), 1);
        //@ts-ignore
        ables.props['favoriteViewable'] = false;
      } else {
        ables.ables.push(FavoriteViewable);
        //@ts-ignore
        ables.props['favoriteViewable'] = true;
      }
    }

    if (this.isMobile && (this.isText || this.isShape || this.isImage || this.isFrame || this.isVideoFrame || this.isIllustration || this.isQR)) {
      ables.ables.push(Options);
      //@ts-ignore
      ables.props['options'] = true;
    }
    return ables;
  }

  private registerListeners() {
    this.registerElementListeners();
    this.registerImageLoadedListener();

    this.registerClickListener();
    this.registerScaleListener();
    this.registerResizeListener();
    this.registerRotateListener();
    this.registerDragListener();
    this.registerSnapListener();
  }

  private registerImageLoadedListener() {
    this.$el.find('img').on('load', () => {
      this.updateRect();
    });
  }

  private registerElementListeners() {
    if (this.isText && this.isMobile) {
      this.$el.find('.txt').on('touchstart', event => {
        if (event && event.originalEvent) {
          this.startX = event.originalEvent.targetTouches[0].pageX;
          this.startY = event.originalEvent.targetTouches[0].pageY;
          Text.endEditMode(this.$el);
        }
      });

      this.$el.find('.txt').on('touchend', event => {
        if (event && event.originalEvent) {
          const delta = 6;
          const diffX = Math.abs(event.originalEvent.changedTouches[0].pageX - this.startX);
          const diffY = Math.abs(event.originalEvent.changedTouches[0].pageY - this.startY);
          if (diffX < delta && diffY < delta && event) {
            requestAnimationFrame(() => {
              this.$el.trigger('click');
            });

            util.setContentEditable(this.$el, 'true');
            //this.$el.find('.ql-editor').focus();

            Text.startEditMode(this.$el);
            const clientX = event.originalEvent.changedTouches[0].clientX;
            const clientY = event.originalEvent.changedTouches[0].clientY;
            this.setCursorAtPosition(clientX, clientY);
          } else {
            util.setContentEditable(this.$el, 'false');
          }
        }
      });
    }

    // this.$el.on('mousedown', e => {
    //   util.nextTick(() => {
    //     this.mov.dragStart(e.originalEvent);
    //   });
    // });
  }

  // ======================================================== DRAG
  private registerDragListener() {
    this.mov
      .on("dragStart", this.onDragStart.bind(this))
      .on("drag", this.onDrag.bind(this))
      .on("dragEnd", this.onDragEnd.bind(this));
  }

  private static dragDelay = 200;
  private dragging = false;
  private dragJustEnded = false;

  private doDragStart(e: OnDragStart) {
    if (this.dragJustEnded && !this.isMobile) {
      this.dragJustEnded = false;
      return;
    }
    this.dragging = true;
    this.onInteractionStart(e, InteractionType.DRAG);
    this.hideControls(true);

    e.set(this.frame.translate);
    e.datas[START_PAGE] = util.getPositionPage(this.$el);

    if (this.$el[0].style.transform.includes('matrix')) {
      this.fixTransform(this.$el);
      this.$el[0].style.transform = this.getTranslate();
    }

    if (!store.getState().isShiftPressed) {
      this.selectElement();
    } else {
      const isMoveableLine = e.inputEvent.target.classList && e.inputEvent.target.classList.contains('moveable-line');
      if (Interactable.getSelected().length && isMoveableLine) {
        this.multiSelectElement();
      }
    }

    if (!this.isMobile && this.isText && !this.mov.checkInput) {
      this.mov.checkInput = true;
    }
  }

  private onDragStart(e: OnDragStart) {
    if (this.shouldStopDragEvent(e)) {
      e.stopDrag();
      return false;
    }
    if (this.isMobile || $(e.target).attr('data-component') === 'text') {
      let doDrag = this.doDragStart.bind(this, e);
      doDrag();
    } else {
      setTimeout(() => {
        let doDrag = this.doDragStart.bind(this, e);
        doDrag();
      }, Interactable.dragDelay)
    }
  }

  private onDrag(e: OnDrag) {
    if (Interactable.MULTIINTERACTABLE) return;
    if (!this.dragging && !this.isMobile) return;

    this.onInteraction(e);
    this.$el.css('z-index', '9999');
    this.frame.translate = e.beforeTranslate;
    e.target.style.transform = this.getTranslate();

    if (this.mov.rotationPosition !== 'none') {
      this.hideControls(true);
    }

    if (this.isGroup) {
      this.getGroupElements().each(function () {
        Interactable.of($(this)).updateRect(true);
      });
    }
  }

  public onDragEnd(e: OnDragEnd, isMulti: boolean = false) {
    this.dragging = false;
    this.dragJustEnded = true;
    setTimeout(() => {
      this.dragJustEnded = false;
    }, Interactable.dragDelay);
    const deleted = this.checkElementAfterDrag(e, isMulti);
    try {
      this.$el.css('z-index', '');
      this.onInteractionEnd(e, InteractionType.DRAG, e.isDrag);
      this.showControls();
    } catch (e) {
      console.error(e);
    }
    return deleted;
  }

  private fixTransform($el: JQuery<AllowedElement>) {
    console.log('fixing transform');
    const transform = JSON.parse($el.attr('data-transform') || '{}');
    const verticalFlip = transform.verticalFlip || false;
    const horizontalFlip = transform.horizontalFlip || false;
    const scale = transform.scale || 100;
    let rotationDeg = parseFloat(transform.rotationDeg) * 180 / Math.PI || 0;
    $el.attr('data-transform', JSON.stringify({
        verticalFlip, horizontalFlip, rotationDeg, scale
    }));
    this.frame.rotate = rotationDeg;
  }

  private shouldStopDragEvent(e: OnDragStart) {
    return this.options.locked ||
      (this.isMobile && !this.isSelected()) ||
      (!Interactable.IS_MOUSE_OVER_PAGE && this.mov.hideDefaultLines) ||
      this.isInGroup() ||
      this.shouldEnableMOItemSorting(e);
  }

  private shouldEnableMOItemSorting(e: OnDragStart) {
    //return (this.isMO && !!e.inputEvent?.composedPath()?.find((it: HTMLElement) => it.classList?.contains('selected')));
    const isMoveableLine = e.inputEvent?.target?.classList?.contains('moveable-line');
    if (isMoveableLine) return false;
    return ((this.isMO && this.sortable) || (this.isMO && this.isSelected() && this.$el.find('.item.selected').length));
  }

  private isAlreadySelected() {
    let isSelected = false;
    store.getState().$elements.forEach(($element: JQuery) => {
      if ($element[0] === this.$el[0]) {
        isSelected = true;
      }
    });
    return isSelected;
  }

  private checkElementAfterDrag(e: OnDragEnd, isMulti: boolean = false) {
    let moved = this.maybeMoveToNewPage(e, isMulti);
    if (moved) {
      if (!isMulti) {
        this.recreateInstance();
      }
    } else {
      return this.maybeRemoveElement();
    }
    return false;
  }

  // ======================================================== ROTATE
  private registerRotateListener() {
    this.mov
      .on("rotateStart", this.onRotateStart.bind(this))
      .on("rotate", this.onRotate.bind(this))
      .on("rotateEnd", this.onRotateEnd.bind(this));
  }

  public onRotateStart(e: OnRotateStart) {
    this.onInteractionStart(e, InteractionType.ROTATE);
    e.set(this.frame.rotate);
  }

  private onRotate(e: OnRotate) {
    this.onInteraction(e);
    if ((e.beforeRotate > 0 && e.beforeRotate < 1) || (e.beforeRotate < 0 && e.beforeRotate > -1)) {
      e.beforeRotate = Math.round(e.beforeRotate);
    }

    this.frame.rotate = e.beforeRotation % 360;

    if (store.getState().isShiftPressed) {
      this.frame.rotate = Math.round(this.frame.rotate / 45) * 45;
    }

    e.target.style.transform = this.getTranslate();
  }

  public onRotateEnd(e: OnRotateEnd) {
    this.onInteractionEnd(e, InteractionType.ROTATE);
  }

  // ======================================================== RESIZE
  private registerResizeListener() {
    this.mov
      .on("resizeStart", this.onResizeStart.bind(this))
      .on("resize", this.onResize.bind(this))
      .on("resizeEnd", this.onResizeEnd.bind(this));
  }

  public onResizeStart(e: OnResizeStart) {
    this.onInteractionStart(e, InteractionType.RESIZE);

    if (!this.isManualResizing) {
      if (this.isRatioConfigurableElement) {
        this.mov.keepRatio = this.$el.attr('data-preserve-ratio') !== 'false';
      }
      if ((this.isFrame || this.isShape || this.isIllustration) && !isCornerDrag(e)) {
        this.mov.keepRatio = false;
      }
    }

    if (this.isText) {
      this.mov.snapThreshold = TEXT_SNAP_THRESHOLD;
    }

    if (isLeftRightDrag(e)) {
      this.mov.snapDirections = LEFT_RIGHT_SNAPS_ENABLED;
      this.mov.elementSnapDirections = LEFT_RIGHT_SNAPS_ENABLED;
    }
    if (isTopBottomDrag(e)) {
      this.mov.snapDirections = TOP_BOTTOM_SNAPS_ENABLED;
      this.mov.elementSnapDirections = TOP_BOTTOM_SNAPS_ENABLED;
    }

    if (!this.isManualResizing) {
      Interactable.setResizeDirection(e);
      this.setEventMinBounds(e);
    }
  }

  public onResize(e: OnResize) {
    if (this.isManualScaling) return;
    this.onInteraction(e);

    if (this.isFrame && !this.isFramePreview) this.handleResizeFrame(e);

    e.delta[0] && (e.target.style.width = `${e.width}px`);
    e.delta[1] && (e.target.style.height = `${e.height}px`);
    this.frame.translate = e.drag.beforeTranslate;
    e.target.style.transform = this.getTranslate();

    this.handleResize(e);
    if (!this.isManualResizing) {
      this.checkControlBars(e);
    }
  }

  private handleResize(e?: OnResize) {
    if (this.isMO) this.handleResizeMenuObject(e);
    if (this.isText) this.handleResizeText(e);
    if (this.isShape) this.handleResizeShape(e);
    this.saveElementState();
  }

  private handleResizeFrame(e?: OnResize) {
    if (e) {
      const ratio = this.getRatio();
      const isSideResize = isLeftRightDrag(e) || isTopBottomDrag(e);
      const edges = {
        left: isLeftDrag(e) || isTopLeftDrag(e) || isBottomLeftDrag(e),
        right: isRightDrag(e) || isTopRightDrag(e) || isBottomRightDrag(e),
        top: isTopDrag(e) || isTopRightDrag(e) || isTopLeftDrag(e),
        bottom: isBottomDrag(e) || isBottomRightDrag(e) || isBottomLeftDrag(e)
      };
      const width = e ? this.getEventWidth(e) : this.getCurrentWidth();
      const height = e ? this.getEventHeight(e) : this.getCurrentHeight();
      this.$el.attr('data-custom-ratio', width / height);
      adjustAfterFrameResize(edges, this.$el, width, height, ratio, isSideResize);
    }
  }

  private handleResizeMenuObject(e?: OnResize) {
    const width = e ? e.width : this.getCurrentWidth();
    this.$el.find('.wrapper').css({'width': `${width}px`});
    MenuObject.ensureKidsHeight(this.$el, this.getScale());
    MenuObject.fixLineHeights(this.$el, true);
    MenuObject.fixDots(this.$el);
    util.nextTick(() => {
      MenuObject.fixHeightWithColumns(this.$el);
    }, 100)
  }

  private handleResizeText(e?: OnResize) {
    /*if (!store.getState().textWrapped) {
      const width = e ? e.width : this.getCurrentWidth();
      this.$el.find('.ql-container').css({'width': `${width}px`});
    } else {
      this.$el.find('.ql-container').css('');
    }*/
    fixComponentLineHeight(this.$el);
    Text.ensureTextSize(this.$el);

    if (store.getState().textWrapped) {
      wrapToCurve(this.$el);
    }
  }

  private handleResizeShape(e?: OnResize) {
    const width = e ? this.getEventWidth(e) : this.getCurrentWidth();
    const height = e ? this.getEventHeight(e) : this.getCurrentHeight();

    const dims = util.getActiveDimensions();
    const widthCfg = {} as STRING_NUMBER_OBJECT;
    widthCfg[dims.unit] = (dims.unit === 'px' ? width : util.pixelToInch(width));
    const heightCfg = {} as STRING_NUMBER_OBJECT;
    heightCfg[dims.unit] = (dims.unit === 'px' ? height : util.pixelToInch(height));
    if (this.isLine) changeLineSize(this.$el, widthCfg);
    else if (this.isSquare) changeSquareSize(this.$el, widthCfg, heightCfg);
    else if (this.isCircle) changeCircleSize(this.$el, widthCfg, heightCfg);
  }

  public onResizeEnd(e: OnResizeEnd) {
    // if (this.options.scalable) {
    //   this.mov.keepRatio = true;
    //   this.mov.scalable = true;
    // }

    if (this.isText) {
      this.mov.snapThreshold = DEFAULT_SNAP_THRESHOLD;
    }
    this.mov.snapDirections = ALL_SNAPS_ENABLED;
    this.mov.elementSnapDirections = ALL_SNAPS_ENABLED;

    this.onInteractionEnd(e, InteractionType.RESIZE);
  }

  // ======================================================== SCALE

  private registerSnapListener() {
    // this.mov.on('snap', e => {
    //   console.log('=> snap', e);
    //
    //  let minGap = Number.MAX_SAFE_INTEGER;
    //  e.gaps.forEach(g => {
    //    if ((g.gap || 0) < minGap) {
    //      minGap = g.gap!;
    //    }
    //  });
    //
    //   e.gaps.forEach(g => {
    //     if ((g.gap || 0) !== minGap) {
    //       g.gapRects!.forEach(gr => {
    //         $(`.${gr.className}.moveable-gap`).parents('.moveable-guideline-group').hide();
    //       });
    //     }
    //   });
    // });
  }

  private registerClickListener() {
    this.mov.on("click", this.onClick.bind(this));
  }

  private onClick(e: OnClick) {
    if (this.isText && this.isMobile) {
      util.setContentEditable(this.$el, 'true');
      //this.$el.find('.ql-editor').focus();

      const clientX = e.inputEvent.changedTouches ? e.inputEvent.changedTouches[0].clientX : e.inputEvent.clientX;
      const clientY = e.inputEvent.changedTouches ? e.inputEvent.changedTouches[0].clientY : e.inputEvent.clientY;

      this.setCursorAtPosition(clientX, clientY);
    }
    if (this.isMO) {
      if (this.isMobile || (window as any).data.props.isTouchScreen) {
        this.refreshSortable();

        const item = e.inputTarget?.closest('.item');
        if (item) {
          if (item.classList.contains('selected')) {
            requestAnimationFrame(() => {
              canvas.onMenuItemClickSelected();
            });
          } else {
            canvas.onMenuItemClick($(item));
          }
        }
      }
    }
  }

  private registerScaleListener() {
    this.mov
      .on("scaleStart", this.onScaleStart.bind(this))
      .on("scale", this.onScale.bind(this))
      .on('scaleEnd', this.onScaleEnd.bind(this));
  }

  public onScaleStart(e: OnScaleStart) {
    let stopped = false;
    if (this.isManualResizing) {
      // @ts-ignore
      e.stop();
      stopped = true;
    }

    if (!stopped) {
      this.onInteractionStart(e, InteractionType.SCALE);
      this.mov.keepRatio = true;

      if (this.isText) {
        this.mov.snapThreshold = TEXT_SNAP_THRESHOLD;
      }

      e.set(this.frame.scale);
      e.dragStart && e.dragStart.set(this.frame.translate);
    } else {
      return false;
    }
  }

  public onScale(e: OnScale) {
    //console.log('scale event');
    //console.log(e.scale);
    if (this.canScale(e)) {
      this.onInteraction(e);
      this.frame.translate = e.drag.beforeTranslate;
      this.frame.scale = e.scale;
      e.target.style.transform = this.getTranslate();

      //this.handleScale(e);
      this.checkControlBars(e);
    }
  }

  private handleScale(e: OnScale) {
    this.saveElementState();
  }

  private canScale(e: OnScale) {
    if (this.isManualResizing) return false;

    const scale = e.scale[0];

    const lengthContraint = this.getEventWidth(e, scale) * getPageZoom() >= SCALE_RESIZE_THRESHOLD && this.getEventHeight(e, scale) * getPageZoom() >= SCALE_RESIZE_THRESHOLD;
    const isScaleUp = e.dist[0] >= 1 || e.dist[1] >= 1;

    return lengthContraint || isScaleUp;
  }

  public groupElementRescale() {
    const scale = this.frame.scale[0];
    const zoom = getPageZoom();
    const scaledWidth = parseFloat(this.$el.css('width')) * zoom;
    const scaledHeight = parseFloat(this.$el.css('height')) * zoom;
    const width = scaledWidth / scale;
    const height = scaledHeight / scale;
    const widthDelta = (scaledWidth - width)/2;
    const heightDelta = (scaledHeight - height)/2;
    this.frame.translate = [this.frame.translate[0] - widthDelta/zoom, this.frame.translate[1] - heightDelta/zoom];
    this.frame.scale = [1, 1];
    this.$el[0].style.transform = this.getTranslate();

    if (this.isFrame) {
      const ratio = this.getRatio();
      const isSideResize = false;
      const edges = {
        left: false,
        right: true,
        top: false,
        bottom: true
      };
      this.$el.attr('data-custom-ratio', width / height);
      adjustAfterFrameResize(edges, this.$el, scaledWidth, scaledHeight, ratio, isSideResize, width, height);
    }
  }

  public groupScaleInteractionEnd(saveState: boolean = true) {
    const type = InteractionType.SCALE;
    const wasElementRemoved = !documentContainsElement(this.$el);

    this.setMouseCursor(type, undefined, true);
    this.isInteracting = false;

    if (!wasElementRemoved) {
      if (saveState) {
        this.saveState();
        this.saveElementState(type);
      }

      hideDimensions();
      this.stopObservingLines();
    } else {
      if (saveState) {
        this.saveState();
        this.saveElementState();
      }
    }
  }

  public onScaleEnd(e: OnScaleEnd) {
    this.mov.keepRatio = this.options.keepRatio;

    if (this.isText) {
      this.mov.snapThreshold = DEFAULT_SNAP_THRESHOLD;
      if (store.getState().textWrapped) {
        wrapToCurve(this.$el);
      }
    }

    this.onInteractionEnd(e, InteractionType.SCALE);
  }

  // ======================================================== HELPERS

  private multiSelectElement() {
    if (this.$el.hasClass('select') && !this.isAlreadySelected()) {
      Renderer.select(this.$el);
      store.dispatch(actions.multiSelect(this.$el));
    }
  }

  private selectElement() {
    if (isMenuItemDataImportMode) return;
    if (this.$el.hasClass('select')) {
      if (!this.isAlreadySelected()) {
        Renderer.deselectAll();
        deselectAll();
        Renderer.select(this.$el, true);
        store.dispatch(actions.select(this.$el));
      }
    }
  }

  private setCursorAtPosition(x: number, y: number) {
    const el = this.$el.find('p').get(0);
    if (el) {
      el.focus();
      if (typeof window.getSelection !== 'undefined' && typeof document.createRange !== 'undefined') {
        const sel = window.getSelection();
        sel?.removeAllRanges();

        let range = document.caretRangeFromPoint(x, y);
        if (!range) {
          range = document.createRange();
          range.selectNodeContents(el);
          range.collapse(false);
        }

        sel?.addRange(range);
        el.focus();
        //@ts-ignore
      } else if (typeof document.body.createTextRange !== 'undefined') {
        //@ts-ignore
        const textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.collapse(false);
        textRange.select();
      }
    }
  }

  private getGroupElements() {
    return this.$el.find('.select');
  }

  private ensureControlsHidden() {
    //@ts-ignore
    if (this.mov.hideDefaultLines && (this.mov.rotationPosition !== 'none' || this.mov.props.mooptions || this.mov.props.options || this.mov.props.favoriteViewable)) {
      this.hideControls(true, true);
    }
  }

  private getCurrentPage() {
    return this.$el.closest('.page');
  }

  private getRatio() {
    let ratio = this.$el.attr('data-temp-ratio') && !Number.isNaN(this.$el.attr('data-temp-ratio')) ? parseFloat(this.$el.attr('data-temp-ratio') || '') : -1;
    if (ratio === -1) {
      ratio = this.$el.attr('data-custom-ratio') && !Number.isNaN(this.$el.attr('data-custom-ratio')) ? parseFloat(this.$el.attr('data-custom-ratio') || '') : -1;
      if (ratio === -1) {
        ratio = !Number.isNaN(this.$el.attr('data-ratio')) ? parseFloat(this.$el.attr('data-ratio') || '') : -1;
      }
    } else {
      this.$el.removeAttr('data-temp-ratio');
    }
    return ratio;
  }

  public recreateInstance() {
    this.destroy();
    Interactable.remove(this);
    util.nextTick(() => {
      const instance = Interactable.of(this.$el);
      instance.select();
    });
  }

  private static shouldHideOtherControls(type: InteractionType) {
    return type === InteractionType.SCALE || type === InteractionType.RESIZE;
  }

  private setMouseCursor(type: InteractionType, e?: OnResizeStart | OnDragStart | OnScaleStart | OnRotateStart, end?: boolean) {
    if (!end) {
      let cursor = '';

      if (type === InteractionType.DRAG) {
        cursor = 'move';
        document.body.style.setProperty('cursor', cursor, 'important');
      } else if (type === InteractionType.SCALE || type === InteractionType.RESIZE) {
        // @ts-ignore
        const edge = getDraggedEdge(e);
        const cursor = this.getControlBox().find(`.moveable-direction[data-direction="${edge}"]`).css('cursor');
        if (cursor) {
          document.body.style.setProperty('cursor', cursor, 'important');
        }
      }
    } else {
      document.body.style.setProperty('cursor', '', '');
    }
  }

  public isInGroup() {
    return !this.isGroup && util.isGroup(this.getElementParent());
  }

  private getParentGroup() {
    return !this.isGroup ? this.$el.closest('.group') : null;
  }

  private getElementParent() {
    return this.$el.parent();
  }

  private hasLockedElements() {
    return !!this.$el.find('.locked').length;
  }

  private static setResizeDirection(e: OnResizeStart) {
    if (isLeftRightDrag(e)) {
      if (e.direction[0] === 1) {
        e.setFixedDirection([-1, -1]);
      }
      if (e.direction[0] === -1) {
        e.setFixedDirection([1, -1]);
      }
    }
  }

  private setEventMinBounds(e: OnResizeStart) {
    let threshold = this.isShape ? SCALE_RESIZE_THRESHOLD_SHAPE : SCALE_RESIZE_THRESHOLD;
    threshold = threshold * this.getScale();

    e.setMin([threshold, threshold]);
  }

  private checkControlBars(e?: OnScale | OnResize) {
    if (this.isSelected() && !this.options.locked && !this.isFramePreview) {
      if (!e || !e.datas[START_DIRECTIONS]) {
        const fewerControls = this.canShowFewerControls();

        const optionsCopy = this.getOptions(this.$el);
        this.options.resizable = optionsCopy.resizable;
        this.options.scalable = optionsCopy.scalable;
        this.options.ables = optionsCopy.ables;
        this.mov.ables = optionsCopy.ables;

        if (fewerControls) {
          if (this.options.scalable) {
            (this.options.scalable as ScalableOptions).renderDirections = ['nw'];
          }
          if (this.options.resizable) {
            let directions = ['e'];
            if (!this.mov.scalable) {
              directions.push('nw');
            }
            (this.options.resizable as ResizableOptions).renderDirections = directions;
          }
        }

        this.mov.resizable = this.options.resizable;
        this.mov.scalable = this.options.scalable;
      }
    }
  }

  private canShowFewerControls() {
    if (this.isLine || this.isMO || this.isText) return false;

    // @ts-ignore
    const h = this.$el[0] ? this.$el[0].offsetHeight : this.$el.outerHeight();
    const height = h * this.getScale() * getPageZoom();

    return height < LIGHT_CONTROLS_THRESHOLD;
  }

  private showControlsActive() {
    this.mov.hideDefaultLines = false;
    this.mov.rotationPosition = this.options.rotationPosition;
    // @ts-ignore
    this.mov.props.dimensionViewable = true;
    // @ts-ignore
    this.mov.props.angleViewable = true;
    // @ts-ignore
    this.mov.props.favoriteViewable = false;

    if (this.isMO) {
      // @ts-ignore
      this.mov.props.mooptions = true;
    }

    if (this.isMobile && (this.isText || this.isShape || this.isImage || this.isFrame || this.isVideoFrame || this.isIllustration || this.isQR)) {
      // @ts-ignore
      this.mov.props.options = true;
    }

    if (this.isImage || this.isFrame || this.isIllustration) {
      // @ts-ignore
      this.mov.props.favoriteViewable = true;
    }

    this.checkControlBars();

    this.mov.draggable = this.options.draggable;
    this.mov.edgeDraggable = this.options.edgeDraggable;
  }

  private showControlsLocked() {
    this.mov.hideDefaultLines = false;
    // @ts-ignore
    this.mov.props.dimensionViewable = true;
    // @ts-ignore
    this.mov.props.favoriteViewable = true;
  }

  private maybeRemoveElement() {
    if (!documentContainsElement(this.$el) || isElementOffPage(this.$el)) {
      store.dispatch(actions.deselect());
      store.dispatch(actions.multiDeselect(this.$el));
      util.nextTick(() => {
        Cleaner.removeElement(this.$el);
      });
      deselectAll();
      return true;
    }
    return false;
  }

  private getControlBox() {
    return $(`.${this.getControlBoxClass()}`);
  }

  public static getElementFromControlBox($elem: JQuery<AllowedElement>) {
    const domEl = $elem.closest('.moveable-control-box')[0];
    return !domEl ? null : $(`#${Interactable.getIdFromClasses(domEl.classList)}`);
  }

  public static getInstanceFromControlBox($elem: JQuery<AllowedElement>) {
    const $el = Interactable.getElementFromControlBox($elem);
    if ($el && $el.length && $el.hasClass('select')) {
      return Interactable.of($el);
    }
    return null;
  }

  private getControlBoxClass() {
    return `${CONTROL_BOX_CLASS_PREFIX}${this.getId()}${this.isFramePreview ? '-frame-preview' : ''}`;
  }

  private getId() {
    return this.$el.attr('id');
  }

  private maybeMoveToNewPage(e: OnDragEnd, isMulti: boolean = false) {
    const $newPage = util.getPositionPage(this.$el);
    let moved = false;
    if ($newPage && e.datas[START_PAGE] && e.datas[START_PAGE][0] !== $newPage[0]) {
      this.$el[0].style.top = '0px';
      this.$el[0].style.left = '0px';

      const controlBox = isMulti ? e.currentTarget.controlBox.getElement() : this.getControlBox()[0];

      const hoverCR = controlBox.getBoundingClientRect();
      const newPageCR = $newPage[0].getBoundingClientRect();

      this.$el.appendTo($newPage.find(".content"));
      this.$el.css({visibility: 'hidden'});

      const zoom = getPageZoom();

      this.frame.translate[0] = (hoverCR.x - newPageCR.x) / zoom;
      this.frame.translate[1] = (hoverCR.y - newPageCR.y) / zoom;

      this.refreshPosition();

      // recalculate the position based on element scale :)
      const newRect = this.$el[0].getBoundingClientRect();
      this.frame.translate[0] += (hoverCR.x - newRect.x) / zoom;
      this.frame.translate[1] += (hoverCR.y - newRect.y) / zoom;
      this.refreshPosition();
      this.$el.css({visibility: 'visible'});

      this.currentPageIdx = parseInt($newPage.attr('id')!.replace('page-', ''));

      moved = true;
    }
    return moved;
  }

  public saveStateOnEvent(e: OnResizeStart | OnDragStart | OnScaleStart | OnRotateStart) {
    e.datas[START_FRAME] = deepCopy(this.frame);
    e.datas[START_STYLE] = this.$el.attr('style');
    e.datas[START_PAGE] = util.getPositionPage(this.$el);
  }

  private getAbleByInteraction(type: InteractionType): ScalableOptions | ResizableOptions {
    return (type === InteractionType.RESIZE ? this.mov.resizable : this.mov.scalable) as ResizableOptions | ScalableOptions;
  }

  private getCurrentRenderDirections() {
    return {
      resizable: (this.mov.resizable as ResizableOptions)?.renderDirections || [],
      scalable: (this.mov.scalable as ScalableOptions)?.renderDirections || []
    }
  }

  private hideAllRenderDirections() {
    if (this.mov.resizable) {
      (this.mov.resizable as ResizableOptions).renderDirections = [];
    }
    if (this.mov.scalable) {
      (this.mov.scalable as ScalableOptions).renderDirections = [];
    }
  }

  private onInteractionStart(e: OnResizeStart | OnDragStart | OnScaleStart | OnRotateStart, type: InteractionType) {
    this.saveStateOnEvent(e);

    if (Interactable.shouldHideOtherControls(type)) {
      const able = this.getAbleByInteraction(type);
      e.datas[START_DIRECTIONS] = this.getCurrentRenderDirections();
      this.hideAllRenderDirections();
      if (able.renderDirections) {
        able.renderDirections = [getDraggedEdge(e as OnResizeStart | OnScaleStart | OnResize | OnScale)];
      }
    }

    if (!this.isMobile) {
      this.setMouseCursor(type, e, false);
    }
    this.isInteracting = true;

    if (type === InteractionType.ROTATE) {
      showAngle();
      hideFavorite();
    }
    if (!this.isManualScaling && !this.isManualResizing && (type === InteractionType.RESIZE || type === InteractionType.SCALE)) {
      showDimensions();
    }
    if (this.options.snappable && (type === InteractionType.DRAG || type === InteractionType.RESIZE || type === InteractionType.SCALE)) {
      this.observeLines();
    }
  }

  private onInteractionEnd(e: OnEndEvent, type: InteractionType, saveState: boolean = true) {
    const wasElementRemoved = !documentContainsElement(this.$el);

    this.setMouseCursor(type, undefined, true);
    this.isInteracting = false;

    if (!wasElementRemoved) {
      if (saveState) {
        this.saveState();
        this.saveElementState(type);
      }
      if (!this.isManualResizing && !this.isManualScaling && !this.isManualDragging && !Interactable.MULTIINTERACTABLE) {
        this.registerEventUndo(type, e);
      }

      if (Interactable.shouldHideOtherControls(type)) {
        if (e.datas[START_DIRECTIONS].resizable && this.mov.resizable) {
          (this.mov.resizable as RenderDirections).renderDirections = e.datas[START_DIRECTIONS].resizable;
        }
        if (e.datas[START_DIRECTIONS].scalable && this.mov.scalable) {
          (this.mov.scalable as ScalableOptions).renderDirections = e.datas[START_DIRECTIONS].scalable;
        }

        this.checkControlBars();
      }

      if (type === InteractionType.ROTATE) {
        hideAngle();
        showFavorite();
      }
      if (type === InteractionType.RESIZE || type === InteractionType.SCALE) {
        hideDimensions();
        if (type === InteractionType.RESIZE) {
          if (this.isText) {
            Text.restartQuill(this.$el);
          }
        }
      }
      if (type === InteractionType.DRAG || type === InteractionType.RESIZE || type === InteractionType.SCALE) {
        this.stopObservingLines();
      }
    } else {
      const oldStyle = e.datas[START_STYLE];
      this.$el.attr('style', oldStyle);
      this.frame = JSON.parse(e.datas[START_FRAME]);

      if (saveState) {
        this.saveState();
        this.saveElementState();
      }
    }
  }

  private onInteraction(e: OnDrag | OnRotate | OnResize | OnScale) {
    if (this.isMO) {
      store.dispatch(actions.setIsMOEditModal(false));
    }
  }

  public cloneCurrentFrame() {
    return deepCopy(this.frame, true)
  }

  public cloneCurrentStyle() {
    return this.$el.attr('style') || '';
  }

  private registerEventUndo(type: InteractionType, e: OnEndEvent) {
    if (!e.datas[START_FRAME]) return;
    const oldFrame = JSON.parse(e.datas[START_FRAME]);
    const newFrame = this.cloneCurrentFrame();

    const oldStyle = e.datas[START_STYLE];
    const newStyle = this.cloneCurrentStyle();

    Interactable.registerUndo([{
      target: this.$el[0],
      oldFrame,
      newFrame,
      oldStyle,
      newStyle
    }], getUndoLabel(type));
  }

  public static registerUndo(events: Undo[], label: string, executeRedos: boolean = false) {
    const undos: (() => void)[] = [];
    const redos: (() => void)[] = [];

    events.forEach(e => {
      const frameChanged = JSON.stringify(e.oldFrame) !== JSON.stringify(e.newFrame);
      const styleChanged = e.oldStyle !== e.newStyle;

      if (frameChanged || styleChanged) {
        const doAction = (el: AllowedElement, frame: Frame, style: string) => {
          const i = Interactable.of(el);

          i.frame = frame;
          i.$el.attr('style', style);

          i.refreshPosition();
          i.handleResize();

          i.saveState();
          i.saveElementState();
        }

        redos.push(() => {
          doAction(e.target, e.newFrame, e.newStyle);
        });

        undos.push(() => {
          doAction(e.target, e.oldFrame, e.oldStyle);
        });
      }
    });

    if (undos.length || redos.length) {
      const allUndos = () => {
        undos.forEach(f => f());
        if (Interactable.MULTIINTERACTABLE) {
          Interactable.MULTIINTERACTABLE.mov.updateRect();
        }
      };
      const allRedos = () => {
        redos.forEach(f => f());
      };

      if (executeRedos) {
        allRedos();
      }

      History.push(allUndos, allRedos, label);
    }
  }

  public getTranslate() {
    return `translate(${this.frame.translate[0]}px, ${this.frame.translate[1]}px)` +
      ` scale(${this.frame.scale[0]}, ${this.frame.scale[1]})` +
      ` rotate(${this.frame.rotate}deg)`;
  }

  private restoreLockedFrameState() {
    const prevState = this.$el.attr(LOCKED_FRAME_ATTR_NAME);
    if (prevState) {
      return JSON.parse(prevState);
    } else {
      return getDefaultFrame();
    }
  }

  private restoreLockedState() {
    const prevState = this.$el.attr(LOCKED_ATTR_NAME);
    if (prevState) {
      return JSON.parse(prevState);
    } else {
      return this.getOptions(this.$el[0]);
    }
  }

  private restoreLockedFrame() {
    const angle = this.$el.attr('data-angle');
    return {
      translate: this.frame.translate || [0, 0],
      scale: this.frame.scale || [1, 1],
      rotate: angle ? util.radToDegree(parseFloat(angle)) : 0
    }
  }

  private restoreRotationFromPrevStyle() {
    try {
      const dataTransform = this.$el.attr('data-transform');
      if (dataTransform) {
        try {
          const dataTrasformObj = JSON.parse(dataTransform);
          if (dataTrasformObj.rotationDeg) {
            this.frame.rotate = dataTrasformObj.rotationDeg;
          }
        } catch (e) {
          console.error(e);
        }
      } else {
        const style = this.$el.attr('style');
        if (style) {
          const transformStyle = style.split(";").filter(it => it.indexOf('transform') > -1);
          if (transformStyle.length) {
            let value = transformStyle[0].split(':')[1];
            if (value && value.indexOf('rotate(') > -1) {
              value = value.substring(value.indexOf('rotate('));
              let isDegree = false;
              if (value.indexOf('rad)') > -1) {
                value = value.substring('rotate('.length, value.indexOf('rad)'));
              }
              if (value.indexOf('deg)') > -1) {
                value = value.substring('rotate('.length, value.indexOf('deg)'));
                isDegree = true;
              }

              const rad = parseFloat(value.trim());
              this.frame.rotate = isDegree ? rad : util.radToDegree(rad);
            } else if (value && value.indexOf('matrix(')) {
              const transform = getComputedStyle(this.$el[0]).transform;
              if (transform !== 'none') {
                this.frame.rotate = decomposeMatrix(new DOMMatrix(transform)).rotation;
              }
            }
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  private restoreState(ops: MoveableOptions) {
    const prevState = this.$el.attr(ATTR_NAME);
    if (prevState) {
      this.frame = JSON.parse(prevState);

      if (this.isMO) {
        const matrix = decomposeMatrix(new DOMMatrix(this.$el.css('transform')));
        let scale = matrix.scaleX;
        if (matrix.scaleX > matrix.scaleY) {
          scale = matrix.scaleY;
        }
        if (scale && this.frame.scale[0] !== scale) {
          this.frame.scale = [scale, scale];
        }
      }
    } else {
      if (this.isMO) {
        let dataScaleAttr = this.$el.attr('data-scale');
        if (dataScaleAttr) {
          let dataScale = parseFloat(dataScaleAttr);
          if (dataScale && this.frame.scale[0] !== dataScale) {
            this.frame.scale = [dataScale, dataScale];
          }
        }
      }

      this.restoreRotationFromPrevStyle();
    }
    if (ops) {
      Object.keys(ops).forEach(opt => {
        if (this.options.hasOwnProperty(opt)) {
          // @ts-ignore
          this.options[opt] = ops[opt];
        }
      });

      if (isElementLocked(this.$el)) {
        this.options.locked = true;
        //this.options.dragArea = false;
      }

      console.log("favorite assets", store.getState().favoriteAssets.length);

      store.getState().favoriteAssets.forEach((favoriteAsset: any) => {
        if (this.$el.attr('data-pixabay-info')) {
          const pixabayInfo = JSON.parse(this.$el.attr('data-pixabay-info') || '{}');

          if (favoriteAsset.assetId == pixabayInfo.id) {
            this.options.favorite = true;
          }
        } else {
          const element = this.$el;
          if (favoriteAsset.assetId === element.attr('data-id') || favoriteAsset.assetId === element.attr('data-asset-id')) {
            this.options.favorite = true;
          }
        }
      });

      this.onOptionsChanged();
    }
  }

  public toggleFavorite() {
    const pixabayInfo = this.$el.attr('data-pixabay-info');
    const dataId = this.$el.attr('data-id');
    const assetId = this.$el.attr('data-asset-id');
    const id = pixabayInfo ? JSON.parse(pixabayInfo).id : dataId ? dataId : assetId ? assetId : '';

    if (this.options.favorite) {
        favoriteAssetService.removeFavoriteAsset(id, store.getState().memberId).then((response) => {
          console.log(response);
          this.reloadFavoriteAssets();
        });
      } else {
        const dataComponent = this.$el.attr('data-component');
        let type = '';
        if (pixabayInfo) {
          type = 'stock-photo';
        } else if (dataComponent === 'illustration') {
          type = 'illustration';
        } else {
          type = 'upload';
        }

        favoriteAssetService.createFavoriteAsset(store.getState().memberId, id, type).then((response) => {
          console.log(response);
          this.reloadFavoriteAssets();
        });
      }
    
    this.options.favorite = !this.options.favorite;
    this.onOptionsChanged();
  }

  private reloadFavoriteAssets() {
    favoriteAssetService.getFavoriteAssets(store.getState().memberId).then(response => {
      console.log("after adding new favorite asset", response.data.length);
      store.dispatch(actions.setFavoriteAssets(response.data));
    })
  }

  public static reloadAndRefreshFavorites() {
    favoriteAssetService.getFavoriteAssets(store.getState().memberId).then(response => {
      store.dispatch(actions.setFavoriteAssets(response.data));
      
      setTimeout(() => {
        this.refreshFavorites();
      }, 100);
    })
    
  }

  public static refreshFavorites() {
    this.INSTANCES.filter(it => it.isValidInstance()).forEach(i => {
      for (const favoriteAsset of store.getState().favoriteAssets) {
        if (i.$el.attr('data-pixabay-info')) {
          const pixabayInfo = JSON.parse(i.$el.attr('data-pixabay-info') || '{}');

          if (favoriteAsset.assetId == pixabayInfo.id) {
            i.options.favorite = true;
            break;
          } else {
            i.options.favorite = false;
          }
        } else {
          const element = i.$el;
          if (favoriteAsset.assetId === element.attr('data-id') || favoriteAsset.assetId === element.attr('data-asset-id')) {
            i.options.favorite = true;
            break;
          } else {
            i.options.favorite = false;
          }
        }
      }
    });
  }

  // private fixPosition() {
  //   if (this.$el && this.$el[0]) {
  //     const left = parseFloat(this.$el.css('left'));
  //     const top = parseFloat(this.$el.css('top'));
  //
  //     if (left) {
  //       this.setTranslateX(this.getTranslateX() + left);
  //       this.$el.css({'left': 0});
  //     }
  //     if (top) {
  //       this.setTranslateY(this.getTranslateY() + top);
  //       this.$el.css({'top': 0});
  //     }
  //     this.$el[0].style.transform = this.getTranslate();
  //   }
  // }

  private saveElementState(type?: InteractionType) {
    const width = this.getCurrentWidth();
    const height = this.getCurrentHeight();

    if (!this.skipSaveInchAttr) {
      //this.$el.attr('data-inch-width', util.pixelToInchV2(this.getRectWidth() / getPageZoom()));
      this.$el.attr('data-inch-width', util.pixelToInch(width));
      this.$el.attr('data-inch-height', util.pixelToInch(height));

      let ratio = 1;
      if (Number.isFinite(util.getActiveDimensions().onePixelRatio)) {
        ratio = util.getActiveDimensions().onePixelRatio;
      }

      this.$el.attr('data-px-width', Math.round(width / ratio));
      this.$el.attr('data-px-height', Math.round(height / ratio));
    }
    if (type === InteractionType.ROTATE) {
      const transform = JSON.parse(this.$el.attr('data-transform') || '{}');
      const verticalFlip = transform.verticalFlip || false;
      const horizontalFlip = transform.horizontalFlip || false;
      const scale = transform.scale || 100;
      let rotationDeg = this.getRotation();
      this.$el.attr('data-transform', JSON.stringify({
        verticalFlip, horizontalFlip, rotationDeg, scale
      }));
    }

    if (type === InteractionType.RESIZE) {
      if (!this.isFramePreview && (this.isFrame || this.isImage || this.isVideoFrame || this.isShape || this.isIllustration)) {
        this.$el.attr('data-custom-ratio', width / height);
      }
    }
  }

  private saveState() {
    this.$el.attr(ATTR_NAME, JSON.stringify(this.frame));
  }

  private saveLockedState() {
    this.$el.attr(LOCKED_ATTR_NAME, JSON.stringify(this.getOptionsForDeepCopy()));
  }

  private saveLockedFrameState() {
    this.$el.attr(LOCKED_FRAME_ATTR_NAME, JSON.stringify(this.frame));
  }

  private onOptionsChanged() {
    this.mov.resizable = this.options.resizable;
    this.mov.scalable = this.options.scalable;
    this.mov.rotatable = this.options.rotatable;
    this.mov.draggable = this.options.draggable;
    this.mov.edgeDraggable = this.options.draggable;
    this.mov.snappable = this.options.snappable;

    this.refreshElementGuidelines();

    if (this.options.snappable) {
      this.mov.snapThreshold = DEFAULT_SNAP_THRESHOLD;
      this.mov.isDisplaySnapDigit = false;
      this.mov.isDisplayInnerSnapDigit = false;
      this.mov.snapGap = false;
      this.mov.snapDirections = ALL_SNAPS_ENABLED;
      this.mov.elementSnapDirections = ALL_SNAPS_ENABLED;
    } else {
      this.mov.snapDirections = ALL_SNAPS_DISABLED;
      this.mov.elementSnapDirections = ALL_SNAPS_DISABLED;
    }

    if (this.options.locked) {
      if (this.isMobile) {
        this.mov.draggable = true;
      }
      this.mov.edgeDraggable = false;
      this.hideControls(false, true);
    } else {
      this.mov.draggable = this.options.draggable;
      this.mov.edgeDraggable = this.options.edgeDraggable;
      this.showControls();
    }
  }

  private getElementGuidelines(addPage: boolean = true) {
    const elementGuidelines = [];//Array.from(document.querySelectorAll('.guides, *[class*="bleed-shadow"]'));
    const $el = this.$el[0];
    this.getCurrentPage().find('*[data-component]').each(function () {
      if ($(this)[0] !== $el) {
        elementGuidelines.push({
          element: $(this)[0],
          className: 'guideline-to-element-' + $(this).attr('id')
        });
      }
    });
    if (addPage) {
      elementGuidelines.push({
        element: this.getCurrentPage()[0],
        className: 'guideline-to-page'
      });
    }
    return elementGuidelines;
  }

  private getEventHeight(e: OnScale | OnResize, scale: number = 0) {
    scale = scale || this.frame.scale[0];
    return Math.round(e.offsetHeight * scale);
  }

  private getEventWidth(e: OnScale | OnResize, scale: number = 0) {
    scale = scale || this.frame.scale[0];
    return Math.round(e.offsetWidth * scale);
  }

  public getRectWidth() {
    return this.getRect().width;
  }

  public getCurrentWidth(withScale: boolean = false) {
    let width = this.$el.width() || 0;
    if (withScale) {
      width *= this.getScale();
    }
    return width;
  }

  public getCurrentHeight(withScale: boolean = false) {
    let height = this.$el.height() || 0;
    if (withScale) {
      height *= this.getScale();
    }
    return height;
  }

  public refreshElementGuidelines() {
    // this.mov.verticalGuidelines = this.getVerticalGuidelines();
    // this.mov.horizontalGuidelines = this.getHorizontalGuidelines();
    if (!isElementLocked(this.$el)) {
      this.mov.elementGuidelines = this.getElementGuidelines();
    } else {
      this.mov.elementGuidelines = [];
    }
  }

  private static getDirectionPos(type: AlignType, direction: AlignDirection, rect: { left: number, top: number, width: number, height: number }): number {
    let size: number;
    let start: number;
    if (type === AlignType.HORIZONTAL) {
      size = rect.height;
      start = rect.top;
    } else {
      size = rect.width;
      start = rect.left;
    }
    if (direction === AlignDirection.START) {
      return start;
    }
    if (direction === AlignDirection.CENTER) {
      return start + size / 2;
    }
    return start + size;
  }

  public alignBottom() {
    this.align(AlignType.HORIZONTAL, AlignDirection.END);
  }

  public alignTop() {
    this.align(AlignType.HORIZONTAL, AlignDirection.START);
  }

  public alignRight() {
    this.align(AlignType.VERTICAL, AlignDirection.END);
  }

  public alignLeft() {
    this.align(AlignType.VERTICAL, AlignDirection.START);
  }

  public alignCenter() {
    this.align(AlignType.VERTICAL, AlignDirection.CENTER);
  }

  public alignMiddle() {
    this.align(AlignType.HORIZONTAL, AlignDirection.CENTER);
  }

  private align(type: AlignType, direction: AlignDirection) {
    const $elements = [this.$el, this.getCurrentPage()];
    Interactable.alignElements(util.getPositionPage($elements[0])[0], $elements, type, direction, this.getCurrentPage());
  }

  // ======================================================== API
  public ensureRatio() {
    if (this.isIllustration) {
      const oldRatio = this.getRatio();
      const newRatio = this.getCurrentWidth() / this.getCurrentHeight();

      if (oldRatio && Math.abs(oldRatio - newRatio) >= 0.4) {
        const newWidth = this.getCurrentHeight() * oldRatio;

        this.mov.keepRatio = false;
        this.mov.keepRatioFinally = false;
        this.mov.resizable = getConfig(ComponentType.ILLUSTRATION).resizable;
        util.nextTick(() => {
          this.resizeWidth(newWidth);
          util.nextTick(() => {
            this.hideControls();
            this.refreshPosition();
          });
        });
      }
    }
  }

  public getRect() {
    return this.mov.getRect();
  }

  public savePositionInfo() {
    this.rectInfo = this.getRect();
  }

  public select() {
    if (!this.isSelected()) {
      if (this.options.locked) {
        this.ensureLocked();
        this.onOptionsChanged();
      }

      if (!this.isFramePreview) {
        this.options.selected = true;

        this.refreshElementGuidelines();
        this.showControls();
        this.updateRect();

        if (this.isInGroup()) {
          Interactable.of(this.getParentGroup()).select();
          /*
          const group = Interactable.of(this.getParentGroup());
          group.select();
          const groupItems = group.getGroupElements().toArray();
          Interactable.MULTIINTERACTABLE = MultiInteractable.getInstance(Interactable.getContainer(), groupItems);
          groupItems.forEach((ns) => Interactable.of(ns).hideControls());
          */
        }

        if (Interactable.isMultiselect()) {
          Interactable.getSelected().forEach(it => {
            if (it.isText) {
              it.mov.checkInput = false;
              Text.endEditMode(it.$el);
            }
          });
        }
      }
    }
  }

  public deselect() {
    if (this.isValidInstance()) {
      this.setDragArea(false);
      this.mov.elementGuidelines = [];
      if (this.isSelected() || this.isMO) {
        this.options.selected = false;

        if (this.isText && this.isMobile) {
          util.setContentEditable(this.$el, 'false');
        }

        this.hideControls();

        if (this.isMO) {
          this.$el.find('.wrapper .selected').removeClass('selected');
          this.destroyMOItemSort();
        }
      }
    }
  }

  public isValidInstance() {
    return !this.destroyed && !this.isFramePreview;
  }

  private getOptionsForDeepCopy(options?: InitialOptions) {
    const copy: Partial<InitialOptions> = {};
    const obj = options || this.options;
    Object.keys(obj).forEach(key => {
      if (!FORBIDDEN_KEYS_TO_CLONE.includes(key)) {
        //@ts-ignore
        copy[key] = obj[key];
      }
    });
    return copy;
  }

  private ensureLocked() {
    this.options.snappable = false;
    this.options.resizable = false;
    this.options.scalable = false;
    this.options.resizable = false;
    this.options.dragArea = false;
  }

  public lock() {
    this.optionsBeforeLock = deepCopy(this.getOptionsForDeepCopy(), true);
    this.saveLockedState();
    this.saveLockedFrameState();

    this.options.locked = true;
    this.ensureLocked();
    this.onOptionsChanged();
    this.showControls();
  }

  public unlock() {
    const prevOptions = this.optionsBeforeLock ? deepCopy(this.optionsBeforeLock, true) : this.restoreLockedState();
    this.options = {
      ...this.options,
      ...prevOptions
    };
    this.frame = this.restoreLockedFrameState();
    if (!this.optionsBeforeLock) {
      this.frame = this.restoreLockedFrame();
      this.restoreRotationFromPrevStyle();
    }
    this.options.selected = true;
    this.optionsBeforeLock = null;
    this.options.locked = false;
    this.options.snappable = true;

    this.onOptionsChanged();
  }

  public refreshPosition(light: boolean = false) {
    if (!this.destroyed) {
      if (this.$el[0].style.transform.includes('matrix')) {
        this.fixTransform(this.$el);
      }
      this.$el[0].style.transform = this.getTranslate();
      this.updateRect(light);
    }
    if (Interactable.isMultiselect()) {
      let nowSelected = Interactable.getSelected();
      nowSelected.forEach((ns) => ns.hideControls());
    }
  }

  public updateRect(light: boolean = false) {
    this.mov.updateRect();
    if (!light && !this.isInteracting) {
      this.checkControlBars();
    }
  }

  public showControls() {
    if (!this.isValidInstance()) return;

    if (this.isInteracting) {
      this.hideControls(true);
      return;
    }

    if (this.options.locked) {
      this.showControlsLocked();
    } else {
      this.showControlsActive();
    }
  }

  public hideControls(keepLines: boolean = false, keepFavorite: boolean = false) {
    if (!keepLines) {
      this.mov.hideDefaultLines = true;
      this.mov.edgeDraggable = false;
      this.mov.resizable = false;
      this.mov.scalable = false;
    } else {
      this.hideAllRenderDirections();
    }
    this.mov.rotationPosition = "none";
    // @ts-ignore
    this.mov.props.dimensionViewable = false;
    // @ts-ignore
    this.mov.props.angleViewable = false;
    // @ts-ignore
    this.mov.props.mooptions = false;
    // @ts-ignore
    this.mov.props.options = false;

    if (!keepFavorite) {
      // @ts-ignore
      this.mov.props.favoriteViewable = false;
    }
  }

  public getFrame() {
    return this.frame;
  }

  public setTranslateX(x: number) {
    this.getFrame().translate[0] = x;
  }

  public setTranslateY(y: number) {
    this.getFrame().translate[1] = y;
  }

  public getTranslateX() {
    return this.getFrame().translate[0];
  }

  public getTranslateY() {
    return this.getFrame().translate[1];
  }

  public getScale() {
    return formatNumber(this.getFrame().scale[0]);
  }

  public setScale(scale: number) {
    this.getFrame().scale = [scale, scale];
  }

  public getRotation() {
    return this.getFrame().rotate;
  }

  public setRotation(rotation: number) {
    this.getFrame().rotate = rotation;
  }

  public setDragArea(dragArea: boolean) {
    if (this.isText && this.isMobile) {
      dragArea = false;
    }

    if (this.mov.dragArea !== dragArea) {
      this.mov.dragArea = dragArea;
    }
  }

  public resizeWidth(offsetWidth: number, saveInchAttr: boolean = true) {
    this.isManualResizing = true;
    this.skipSaveInchAttr = !saveInchAttr;
    this.mov.request("resizable", {offsetWidth}, true);
    this.isManualResizing = false;
    this.skipSaveInchAttr = false;
  }

  public afterRestore() {
    this.refreshPosition();
    this.handleResize();
    this.refreshPosition();
    this.checkControlBars();
  }

  public resizeHeight(offsetHeight: number, saveInchAttr: boolean = true) {
    this.isManualResizing = true;
    this.skipSaveInchAttr = !saveInchAttr;
    this.mov.request("resizable", {offsetHeight}, true);
    this.isManualResizing = false;
    this.skipSaveInchAttr = false;
  }

  public resize(offsetWidth: number, offsetHeight: number) {
    this.isManualResizing = true;
    this.mov.request("resizable", {offsetHeight, offsetWidth}, true);
    this.isManualResizing = false;
  }

  public moveTo(x: number, y: number) {
    this.isManualDragging = true;
    this.mov.request("draggable", {x, y}, true);
    this.isManualDragging = false;
  }

  public scale(delta: number) {
    const width = this.getCurrentWidth(true);
    //const height = this.getCurrentHeight(true);
    this.isManualScaling = true;
    this.mov.request("scalable", {deltaWidth: delta, deltaHeight: delta, keepRatio: true}, true);
    this.isManualScaling = false;

    //this.resize(width / this.getScale(), height / this.getScale());
    this.resizeWidth(width / this.getScale());
  }

  public handleFontSizeChange(scale?: number) {
    const oldRect = this.mov.getRect();
    const width = oldRect.offsetWidth;
    const prevScale = this.getScale();
    const pageZoom = getPageZoom();

    this.rectInfo = null;

    this.setScale(scale || 1);
    const scaleToMultiply = scale === 1 ? prevScale : (1 / scale!);

    this.$el.css({visibility: 'hidden'});
    this.getControlBox().css({visibility: 'hidden'});

    this.resizeWidth(width * scaleToMultiply);
    if (!this.isMobile) {
      this.moveTo(oldRect.pos1[0], oldRect.pos1[1]);
    }

    const newRect = this.mov.getRect();
    const xDiff = (newRect.pos1[0] - oldRect.pos1[0]) / pageZoom;
    const yDiff = (newRect.pos1[1] - oldRect.pos1[1]) / pageZoom;

    // this.setTranslateX(this.getTranslateX() - xDiff);
    // this.setTranslateY(this.getTranslateY() - yDiff);

    this.refreshPosition();

    this.$el.css({visibility: 'visible'});
    this.getControlBox().css({visibility: 'visible'});
  }

  private initSortable() {
    if (!this.isMO) return;

    const $items = this.$el.find('.items');
    const el = $items[0];
    const itemsNumber = $items.find('.item').length;
    if (!this.isMobile && (itemsNumber === 1 || this.sortable?.el === el)) return;

    this.sortable = Sortable.create(el, {
      ...SORTABLE_OPTIONS,
      onUpdate: (evt) => {
        const oldIdx = evt.oldIndex!;
        const newIdx = evt.newIndex!;
        let items = store.getState().menuObjectItems;
        const oldItems = [...items];

        insertAndShift(items, oldIdx, newIdx);

        // @ts-ignore
        MenuObject.updateContent(this.$el, items, true, true, true, true, oldItems);

        util.nextTick(() => {
          this.$el.find('.items .item').eq(newIdx).addClass('selected');
          store.dispatch(actions.setMoLastSortDate(new Date().getTime()));
          store.dispatch(actions.setMoSelectedItemIdx(newIdx));
        });
      }
    });
  }

  private destroyMOItemSort() {
    util.nextTick(() => {
      this.destroySortable();
    });
  }

  public destroySortable() {
    if (this.sortable) {
      this.sortable?.destroy();
      this.sortable = null;
    }
  }

  public getElement() {
    return this.$el;
  }

  public isSelected() {
    return this.options.selected;
  }

  public isSortable() {
    return !!this.sortable;
  }

  public refreshSortable() {
    this.destroySortable();
    this.initSortable();
  }

  public isLocked() {
    return this.options.locked;
  }

  public isFavorite() {
    return this.options.favorite;
  }
}
